import { useAuth } from "@/lib/auth/AuthContext";

// TODO: This needs to be changed based on the integration context
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.permissions?.includes("tenant.admin") ?? false;
}
